module.exports = __webpack_public_path__ + "static/media/DSC02373.87f306d8.jpg";